import moment from 'moment'

const momentService = {
    date: (format = 'YYYY-MM-DD HH:mm:ss') => {
        return moment().utcOffset(5).format(format)
    },

    unix: () => {
        return moment().utcOffset(5).unix()
    },
}

export default momentService
